import { useState } from "react";
import ArrowLeft from "../../../../assets/icons/ArrowLeft";
import Cross from "../../../../assets/icons/Cross";
import { Activity, MeetupsTableItemType } from "../../../../types";
import DefaultButton from "../../../default-button/DefaultButton";
import { accessGlobalMiscState } from "../../../../stores/misc";
import InputField from "../../../input-field/InputField";
import { showSnackbar } from "../../../../misc/utils";
import { simpleGetter } from "../../../../actions/common";
import { activitiesApi } from "../../../../api/api";
import Tick from "../../../../assets/icons/Tick";
import { Megaphone } from "../../../../assets/icons/Megaphone";

export const MeetupsApproveModal = () => {
    const currentMeet: Activity = accessGlobalMiscState().get('meetupsFormEditItem');
    const updateStatus = (status: number) => async () => {
        const response = await simpleGetter(activitiesApi.createActivity, { id: currentMeet.id, status });
        showSnackbar(
            response.success ? "Успешно" : "Произошла ошибка",
            response.success ? "success" : "error"
        );
        if (response.success) {
            accessGlobalMiscState().setBatch({
                activitiesTriggerFetch: (accessGlobalMiscState().get("activitiesTriggerFetch") || 0) + 1,
                isMeetupsApproveModalOpen: false
            })
        }
    }

    return (
        <div className="flex flex-col">
            <p className="font-normal text-[24px] text-valley-black">
                {currentMeet?.name}
            </p>
            <p className="font-normal text-[15px] text-[#5F6B88]">
                Опубликовать мероприятие?
            </p>
            <div className="flex flex-row gap-2 mt-6">
                <DefaultButton
                    buttonText="Опубликовать"
                    additionalStyle="flex-1 bg-valley-dark-green text-white px-8 py-3 text-nowrap"
                    Icon={Tick}
                    onClick={updateStatus(2)}
                />
                <DefaultButton
                    buttonText="Одобрить без опубликования"
                    additionalStyle="flex-1 bg-valley-main text-white px-8 py-3 text-nowrap"
                    Icon={Megaphone}
                    onClick={updateStatus(1)}
                />
            </div>
        </div>
    )
}